module.exports = __webpack_public_path__ + "img/img@3x.8588ba53.png";